<template>
  <div class="page_unit_detail">
    <el-drawer
      title="单位管理详情"
      :visible.sync="showDetailDrawer"
      :size="drawarWidth"
      :before-close="handleDrawerClose"
      :append-to-body="true"
      :wrapperClosable="false"
      class="custom_drawer_y"
    >
      <div class="drawer_content">
        <div class="title_unit_name">
          {{ appDetail.appName }}
        </div>
        <div class="unit_info">
          <div class="base_info">
            <span class="cell"
              ><span class="gray">省份：</span>{{ appDetail.provinceStr }}</span
            >

            <span class="cell"
              ><span class="gray">城市：</span>{{ appDetail.cityStr }}</span
            >
            <span class="cell"
              ><span class="gray">单位简称：</span
              >{{ appDetail.appShortName }}</span
            >
            <span class="cell"
              ><span class="gray">单位编码：</span>{{ appDetail.appCode }}</span
            >
            <span class="cell"
              ><span class="gray">创建日期：</span
              >{{ appDetail.createTime }}</span
            >
            <span class="cell"
              ><span class="gray">创建人：</span
              >{{ appDetail.createUserName }}</span
            >
          </div>

          <div class="month_count">
            <div class="count count_0">
              <div class="number">{{ appStatistics.dmCreateCountUp }}</div>
              <div class="content">上月新建纪念堂总数</div>
            </div>
            <div class="line"></div>
            <div class="count">
              <div class="number green">{{ appStatistics.dmCreateCount }}</div>
              <div class="content">本月新建纪念堂总数</div>
            </div>
            <div class="line"></div>
            <div class="count">
              <div class="number">{{ appStatistics.amUseCountUp }}</div>
              <div class="content">上月告别会场次总数</div>
            </div>
            <div class="line"></div>
            <div class="count">
              <div class="number green">{{ appStatistics.amUseCount }}</div>
              <div class="content">本月告别会场次总数</div>
            </div>
            <div class="line"></div>
            <div class="count">
              <div class="number">
                {{ appStatistics.dmVisitRelationCountUp }}
              </div>
              <div class="content">上月访问码浏览总数</div>
            </div>
            <div class="line"></div>
            <div class="count">
              <div class="number green">
                {{ appStatistics.dmVisitRelationCount }}
              </div>
              <div class="content">本月访问码浏览总数</div>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="title_tab_area">
          <div
            :class="`btn ${detailCurrentTabId == 1 ? 'selected' : ''}`"
            @click="btnTabClick(1)"
          >
            告别会
          </div>
          <div
            :class="`btn ${detailCurrentTabId == 2 ? 'selected' : ''}`"
            @click="btnTabClick(2)"
          >
            告别厅
          </div>
          <div
            :class="`btn ${detailCurrentTabId == 3 ? 'selected' : ''}`"
            @click="btnTabClick(3)"
          >
            运营帐号
          </div>
          <div
            :class="`btn ${detailCurrentTabId == 4 ? 'selected' : ''}`"
            @click="btnTabClick(4)"
          >
            生平模板
          </div>
          <el-button
            class="btn_create"
            @click="btnCreateHallClick"
            v-show="detailCurrentTabId == 2 && pms.createHall"
          >
            <div class="btn_content">
              <div class="icon-create"></div>
              <div class="text_create">新建</div>
            </div>
          </el-button>
          <el-button
            class="btn_create"
            @click="btnCreateTemplateClick"
            v-show="detailCurrentTabId == 4 && pms.createTemplate"
          >
            <div class="btn_content">
              <div class="icon-create"></div>
              <div class="text_create">新建</div>
            </div>
          </el-button>
        </div>
        <div class="table_1_area" v-show="detailCurrentTabId == 1">
          <el-table :data="ceremoryTableData">
            <el-table-column :width="6 * docFontSize"></el-table-column>
            <el-table-column
              prop=""
              label="告别厅使用日期"
              :width="16 * docFontSize"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.useDate }}</div>
                <div>
                  {{ scope.row.startTime.substring(0, 5) }}-{{
                    scope.row.endTime.substring(0, 5)
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              :width="9.1 * docFontSize"
            >
              <template slot-scope="scope">
                {{ scope.row.status | ceremoryStatus }}
              </template>
            </el-table-column>
            <el-table-column
              prop="dmName"
              label="逝者姓名"
              :width="12.2 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="dmCode"
              label="纪念堂编号"
              :width="15.2 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="fhName"
              label="告别厅"
              :width="12 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="dmCreateTime"
              label="纪念堂创建时间"
              :width="12.3 * docFontSize"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.dmCreateTime.split(" ")[0] }}</div>
                <div>{{ scope.row.dmCreateTime.split(" ")[1] }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="takerName"
              label="主办人昵称"
              :width="11.4 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="takerTel"
              label="主办人手机号"
              :width="12.8 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="updateUserName"
              label="操作员"
            ></el-table-column>
          </el-table>
        </div>
        <div class="table_2_area" v-show="detailCurrentTabId == 2">
          <el-table :data="hallTableData">
            <el-table-column :width="14 * docFontSize"></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建日期"
              :width="20.8 * docFontSize"
            >
              <template slot-scope="scope">
                {{ scope.row.createTime.split(" ")[0] }}
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="告别厅名称"
              :width="23.4 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="code"
              label="告别厅编号"
              :width="22.9 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="amCount"
              label="告别会数量"
              :width="22.9 * docFontSize"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="btnHallEditClick(scope.row)"
                  v-if="pms.editHall"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  style="color: #ff4a24"
                  @click="btnHallDeleteClick(scope.row)"
                  v-if="pms.deleteHall"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table_3_area" v-show="detailCurrentTabId == 3">
          <el-table :data="accountTableData">
            <el-table-column :width="4 * docFontSize"></el-table-column>
            <el-table-column
              prop="createTime"
              label="创建日期"
              :width="16 * docFontSize"
            >
              <template slot-scope="scope">
                {{ scope.row.createTime.split(" ")[0] }}
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="登录帐号"
              :width="18 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="enterpriseMobile"
              label="企业微信号"
              :width="18 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="nick"
              label="使用者"
              :width="18.9 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="tel"
              label="手机号"
              :width="17.0 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="roleName"
              label="岗位名称"
              :width="16.9 * docFontSize"
            ></el-table-column>
            <el-table-column prop="state" label="状态">
              <template slot-scope="scope">
                {{ scope.row.state | accountState }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table_4_area" v-show="detailCurrentTabId == 4">
          <el-table :data="templateTableData">
            <el-table-column :width="8.0 * docFontSize"></el-table-column>
            <el-table-column
              prop="name"
              label="模板标题"
              :width="16.0 * docFontSize"
            ></el-table-column>
            <el-table-column
              prop="lifeStory"
              label="模板内容"
              :width="68.0 * docFontSize"
            >
            <template slot-scope="scope">
                <div class="cell_template_content">{{  scope.row.lifeStoryText }}</div>
              </template>
          </el-table-column>
            <el-table-column label="模板操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="btnTemplateEditClick(scope.row)"
                  v-if="pms.editTemplate"
                  >修改</el-button
                >
                <el-button
                  type="text"
                  style="color: #ff4a24"
                  @click="btnTemplateDeleteClick(scope.row)"
                  v-if="pms.deleteTemplate"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div
          class="pagination_area"
          v-show="
            detailCurrentTabId == 1 ||
            detailCurrentTabId == 2 ||
            detailCurrentTabId == 3
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="detailPageData.page"
            :page-sizes="[20, 50, 100]"
            :page-size="detailPageData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="detailPageData.total"
          >
          </el-pagination>
        </div>
        <!-- <div>{{ appDetail }}</div> -->
      </div>
    </el-drawer>
    <!-- 新建告别厅 -->
    <el-dialog
      :title="createHallData.id ? '修改告别厅' : '新建告别厅'"
      :visible.sync="showCreateHallDialog"
      width="61rem"
      :before-close="handleHallDialogClose"
      :close-on-click-modal="false"
      class="dialog_unit_create partI"
    >
      <el-form
        :model="createHallData"
        ref="formCreateHall"
        label-width="25rem"
        :rules="createHallRules"
      >
        <el-form-item prop="name" label="告别厅名称：">
          <el-input
            v-model.trim="createHallData.name"
            placeholder="请输入告别厅名称"
            maxlength="30"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateHallDialog = false">取消</el-button>
        <el-button type="primary" @click="btnDoneCreateHallClick"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新建模板 -->
    <el-dialog
      :title="createTemplateData.id ? '编辑模板' : '新建模板'"
      :visible.sync="showCreateTemplateDialog"
      width="70rem"
      :before-close="handleTemplateDialogClose"
      :close-on-click-modal="false"
      class="dialog_unit_create partI"
    >
      <el-form
        :model="createTemplateData"
        ref="formCreateTemplate"
        label-width="11.5rem"
        :rules="createTemplateRules"
      >
        <el-form-item prop="name" label="模板标题：">
          <el-input
            v-model.trim="createTemplateData.name"
            class="template_title"
            placeholder="请输入模板标题"
            maxlength="20"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="content" label="模板内容：">
          <div style="width: 55rem" class="wang_editor_all">
            <div ref="editorElem" style="text-align: left"></div>
            <div class="wang_editor_all_number">
              <span
                :style="
                  editorTextLength > 20100 ? 'color:red' : 'color:#2C90FF'
                "
                >{{ editorTextLength }}</span
              >/20100
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCreateTemplateDialog = false">取消</el-button>
        <el-button type="primary" @click="btnDoneCreateTemplateClick"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixins from "./Mixins";
import wangE from "wangeditor";
const { $, BtnMenu, DropListMenu, PanelMenu, DropList, Panel, Tooltip } = wangE;
class AlertMenu extends BtnMenu {
  constructor(editor) {
    const $elem = wangE.$(
      `<div class="w-e-menu" data-title="首行缩进">
                <i class="w-e-icon-indent-increase"></i>
            </div>`
    );
    super($elem, editor);
  }
  // 菜单点击事件
  clickHandler() {
    let domThis = this.editor.selection.getSelectionContainerElem().elems[0];
    if (domThis.style["text-indent"] == "2em") {
      domThis.style["text-indent"] = "0";
      this.unActive();
    } else {
      domThis.style["text-indent"] = "2em";
      this.active();
    }
  }
  tryChangeActive() {
    let domThis = this.editor.selection.getSelectionContainerElem().elems[0];
    if (domThis.style["text-indent"] == "2em") {
      this.active();
    } else {
      this.unActive();
    }
  }
}
export default {
  mixins: [mixins],
  data() {
    return {
      // 130.0 * docFontSize

      pms: {
        createHall: false,
        editHall: false,
        deleteHall: false,
      },
      showCreateHallDialog: false,
      showCreateTemplateDialog: false,
      createHallData: { name: "" },
      createHallRules: {
        name: [
          { required: true, message: "请输入告别厅名称", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "请输入2-30位的告别厅名称",
            trigger: "blur",
          },
        ],
      },
      createTemplateData: { name: "", content: "" },
      createTemplateRules: {
        name: [{ required: true, message: "请输入模板标题", trigger: "blur" }],
      },
      editorContent: null,
      textWithoutNbsp: "",

      editorTextLength: 0,
    };
  },
  watch:{
    showCreateTemplateDialog(v) {
      if(!v) {
        this.editorContent.destroy();
        this.editorContent = null;
      }
    }
  },
  computed: {
    showDetailDrawer: {
      get() {
        return this.Unit.showDetailDrawer;
      },
      set(v) {
        this.SETOPTIONS({
          showDetailDrawer: v,
        });
      },
    },
    detailCurrentTabId: {
      get() {
        return this.Unit.detailCurrentTabId;
      },
      set(v) {
        this.SETOPTIONS({
          detailCurrentTabId: v,
        });
      },
    },
    detailAppId() {
      return this.Unit.detailAppId;
    },
    appDetail() {
      return this.Unit.appDetail;
    },
    appStatistics() {
      return this.Unit.appStatistics;
    },
    hallTableData() {
      return this.Unit.hallTableData;
    },
    ceremoryTableData() {
      return this.Unit.ceremoryTableData;
    },
    accountTableData() {
      return this.Unit.accountTableData;
    },
    templateTableData() {
      return this.Unit.templateTableData;
    },
    detailPageData() {
      return this.Unit.detailPageData;
    },
    drawarWidth() {
      let result = 130.0 * this.docFontSize;
      let percent = (result / document.body.clientWidth) * 100;
      return `${percent}%`;
    },
  },
  filters: {
    ceremoryStatus(v) {
      if (v == 1) {
        return "已预约";
      } else if (v == 2) {
        return "已完成";
      } else {
        return "";
      }
    },
    accountState(v) {
      // 0停用、1启用、2解绑
      if (v == 0) {
        return "停用";
      } else if (v == 1) {
        return "启用";
      } else if (v == 2) {
        return "解绑";
      } else {
        return "";
      }
    },
  },
  created() {
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.pms.createHall = pms["20501"].check;
    this.pms.deleteHall = pms["20502"].check;
    this.pms.editHall = pms["20503"].check;
    this.pms.createTemplate = pms["20504"].check;
    this.pms.deleteTemplate = pms["20505"].check;
    this.pms.editTemplate = pms["20506"].check;
  },
  mounted() {},
  methods: {
    handleDrawerClose() {
      this.showDetailDrawer = false;
    },
    btnTabClick(index) {
      if (this.detailCurrentTabId != index) {
        this.detailCurrentTabId = index;
        this.SETOPTIONS({
          detailPageData: {
            page: 1,
            size: this.detailPageData.size,
            total: 0,
          },
        });
        this.getTableData();
      }
    },
    handleSizeChange() {
      this.getTableData();
    },
    handleCurrentChange() {
      this.getTableData();
    },
    getTableData() {
      if (this.detailCurrentTabId == 1) {
        this.getCeremonyList_A();
      } else if (this.detailCurrentTabId == 2) {
        this.getHallList_A();
      } else if (this.detailCurrentTabId == 3) {
        this.getAccountList_A();
      } else if (this.detailCurrentTabId == 4) {
        this.getTemplateAllList_A();
      }
    },
    // 告别厅
    btnHallEditClick(row) {
      this.createHallData = {
        id: row.id,
        name: row.name,
      };
      if (this.$refs.formCreateHall) {
        this.$refs.formCreateHall.clearValidate();
      }
      this.showCreateHallDialog = true;
    },
    btnHallDeleteClick(row) {
      this.$Confirm("信息删除后将无法恢复，确定要删除该信息吗？", "提示", {
        type: "warning",
        customClass: "partI",
        closeOnClickModal: false,
      })
        .then(async () => {
          let result = await this.deleteHall_A(row.id);
          if (result) {
            this.getHallList_A();
            this.getUnitDetailWithId_A();
          }
        })
        .catch(() => {});
    },
    btnCreateHallClick() {
      this.createHallData = {
        name: "",
      };
      if (this.$refs.formCreateHall) {
        this.$refs.formCreateHall.clearValidate();
      }
      this.showCreateHallDialog = true;
    },
    btnDoneCreateHallClick() {
      this.$refs.formCreateHall.validate(async (result) => {
        if (result) {
          if (this.createHallData.id) {
            let success = await this.createOrEditHall_A({
              unitId: this.detailAppId,
              id: this.createHallData.id,
              name: this.createHallData.name,
            });
            if (success) {
              this.showCreateHallDialog = false;
              this.getHallList_A();
            }
          } else {
            let success = await this.createOrEditHall_A({
              unitId: this.detailAppId,
              name: this.createHallData.name,
            });
            if (success) {
              this.SETOPTIONS({
                detailPageData: {
                  page: 1,
                  size: this.detailPageData.size,
                  total: 0,
                },
              });
              this.showCreateHallDialog = false;
              this.getHallList_A();
              this.getUnitDetailWithId_A();
            }
          }
        }
      });
    },
    handleHallDialogClose() {
      // this.SETOPTIONS({
      //   createHallData: {
      //     name: "",
      //   },
      // });
      this.createHallData = {
        name: ""
      };
      this.showCreateHallDialog = false;
      if (this.$refs.formCreateHall) {
        this.$refs.formCreateHall.clearValidate();
      }
    },
    // 模板
    btnCreateTemplateClick() {
      if(this.templateTableData.length >= 10) {
        this.$message.error('单位纪念堂生平模板不能大于10个');
        return;
      }
      this.createTemplateData = {
        id:"",
        name: "",
        content: ""
      };
      if (this.$refs.formCreateTemplate) {
        this.$refs.formCreateTemplate.clearValidate();
      }
      this.showCreateTemplateDialog = true;
      if (!this.editorContent) {
        this.$nextTick(() => {
          this.initWangEditor();
        });
      } else {
        this.editorContent.txt.html("")
      }
    },
    btnTemplateEditClick(row) {
      this.createTemplateData = {
        id: row.id,
        name: row.name,
        content: row.lifeStory
      };
      if (this.$refs.formCreateTemplate) {
        this.$refs.formCreateTemplate.clearValidate();
      }
      this.showCreateTemplateDialog = true;
      if (!this.editorContent) {
        this.$nextTick(() => {
          this.initWangEditor(row.lifeStory);
        });
      } else {
        this.editorContent.txt.html(row.lifeStory)
      }
    },
    btnDoneCreateTemplateClick() {
      if(this.editorTextLength <= 0) {
        this.$message.error('模板内容不能为空');
        return;
      }
      this.$refs.formCreateTemplate.validate(async (result) => {
        if (result) {
          if (this.createTemplateData.id) {
            let success = await this.templateCreateOrEdit_A({
              id: this.createTemplateData.id,
              unitId: this.detailAppId,
              name: this.createTemplateData.name,
              lifeStory: this.createTemplateData.content,
            });
            if (success) {
              this.showCreateTemplateDialog = false;
              this.getTemplateAllList_A();
            }
          } else {
            let success = await this.templateCreateOrEdit_A({
              unitId: this.detailAppId,
              name: this.createTemplateData.name,
              lifeStory: this.createTemplateData.content,
            });
            if (success) {
              this.showCreateTemplateDialog = false;
              this.getTemplateAllList_A();
            }
          }
        }
      });
    },
    btnTemplateDeleteClick(row) {
      this.$Confirm("信息删除后将无法恢复，确定要删除该信息吗？", "提示", {
        type: "warning",
        customClass: "partI",
        closeOnClickModal: false,
      })
        .then(async () => {
          let result = await this.deleteTemplate_A(row.id);
          if (result) {
            this.getTemplateAllList_A();
          }
        })
        .catch(() => {});
    },
    handleTemplateDialogClose() {
      this.createTemplateData = {
        name: "",
        content: "",
      };
      this.showCreateTemplateDialog = false;
      if (this.$refs.formCreateTemplate) {
        this.$refs.formCreateTemplate.clearValidate();
      }
    },
    initWangEditor(html = "") {
      this.editorContent = new wangE(this.$refs.editorElem);
      // 编辑器的事件，每次改变会获取其html内容
      this.editorContent.config.onchange = (html) => {
        console.log(html);
        if (this.editorContent.txt.text().replace(/&nbsp;/g, "").length > 20100) {
          this.editorContent.txt.html(this.createTemplateData.content);
        } else {
          this.createTemplateData.content = html;
          let textWithnbsp = this.editorContent.txt.text();
          this.textWithoutNbsp = textWithnbsp.replace(/&nbsp;/g, "");
          this.editorTextLength = this.textWithoutNbsp.length;
        }
      };

      this.editorContent.config.menus = [
        // 菜单配置
        "bold",
        "underline",
        "lineHeight",
        "justify",
        "customIndent",
        "undo",
        "redo",
      ];
      const menuKey1 = ""; // 菜单 key ，各个菜单不能重复
      this.editorContent.menus.extend("customIndent", AlertMenu);

      // 将菜单加入到 editor.config.menus 中
      // 也可以通过配置 menus 调整菜单的顺序，参考【配置菜单】部分的文档
      this.editorContent.config.menus = this.editorContent.config.menus.concat(menuKey1);
      this.editorContent.config.showFullScreen = false;
      this.editorContent.config.focus = false;
      this.editorContent.config.placeholder = "";
      this.editorTextLength = 0;
      this.$nextTick(()=>{
        this.editorContent.create();
        this.editorContent.txt.html(html);
      })
      
    },
  },
};
</script>


<style lang="stylus" scoped>
.custom_drawer_y {
  .drawer_content {
    overflow: auto;
    position: absolute;
    top: 108px;
    left: 0;
    bottom: 0;
    right: 0;

    .title_unit_name {
      border: #CCD7EA solid 1px;
      padding-left: 30px;
      height: 60px;
      font-size: 16px;
      background-color: #F1F4F9;
      line-height: 60px;
      font-weight: 500;
    }

    .unit_info {
      border: #CCD7EA solid 1px;
      border-top: 0;
      height: 224px;

      .base_info {
        border-bottom: 1px solid #CCD7EA;
        height: 81px;
        font-size: 14px;
        color: #000;
        margin: 0 30px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .cell {
          margin-right: 30px;
        }

        .gray {
          color: #949494;
          margin-right: 10px;
        }
      }

      .month_count {
        height: 142px;
        overflow: auto;

        .count {
          height: 100%;
          float: left;

          .number {
            color: #000;
            font-size: 30px;
            text-align: center;
            height: 42px;
            line-height: 42px;
            margin-top: 30px;

            &.green {
              color: #00D37A;
            }
          }

          .content {
            color: #949494;
            font-size: 14px;
            text-align: center;
            height: 20px;
            line-height: 20px;
            margin-top: 20px;
            padding: 0 34px;
          }

          &.count_0 {
            // width: 184px;
            margin-left: 14px;
          }
        }

        .line {
          width: 4px;
          height: 40px;
          background-color: #E8EDF5;
          margin-top: 47px;
          float: left;
        }
      }
    }

    .title_tab_area {
      margin-top: 20px;
      height: 60px;

      .btn {
        width: 120px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        color: #000;
        font-size: 16px;
        border: 1px solid #CCD7EA;
        float: left;
        border-bottom: 0;
        cursor: pointer;

        &:not(:first-child) {
          border-left: 0;
        }

        &.selected {
          background-color: #F1F4F9;
        }
      }

      .btn_create {
        background-color: #2C90FF;
        width: 100px;
        height: 40px;
        color: #fff;
        padding: 0 20px;
        float: right;

        .btn_content {
          display: flex;
          align-items: center;
        }

        .icon-create {
          background: url('~@/assets/images/Total/icon_create.png') no-repeat;
          width: 18px;
          height: 18px;
          display: inline-block;
          margin-right: 10px;
          background-size: 100%;
        }

        .text_create {
          display: inline-block;
        }
      }
    }

    .pagination_area {
      height: 30px;
      text-align: center;
      padding: 30px 0;
      border: 1px solid #CCD7EA;
      border-top: 0;
    }
  }
}

.template_title {
  width: 550px !important;
}
.cell_template_content {
  width: 630px;
  height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wang_editor_all_number {
  position: absolute;
  right: 20px;
  bottom: 10px;
  z-index: 100;
}

.wang_editor_all {
  position: relative;
}

.wang_editor_all >>> .w-e-text-container {
  z-index: 100 !important;
}

.wang_editor_all >>> .w-e-menue-mantle {
  z-index: 100 !important;
}

.wang_editor_all >>> .w-e-toolbar {
  z-index: 101 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/PartI/UnitManagement/components/unitDetail.vue